<ng-container *ngIf="segment">
	<copo-tensile [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-tensile>
	<copo-anisotropy [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-anisotropy>
	<copo-bake-hardening [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-bake-hardening>
	<copo-hardness [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-hardness>
	<copo-notch [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-notch>
	<copo-erichsen [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-erichsen>
	<copo-bending [isValidServiceAvailable]="isValidServiceAvailable" [segment]="segment"></copo-bending>
</ng-container>
